import type { ContentStatement } from "@shared/content-statement";
import type { SupportOrderView } from "@shared/tvod-support";
import { jsonBody, unwrap } from "./foyer";

/**
 * Nenda staff's consumer TVOD money and support routes (wave 2 slice F,
 * `api/tvodStaff.ts`). Staff only (`canManageDistribution` + Nenda staff).
 */
export const tvodStaffApi = {
  /**
   * A provider's statement, exactly as the provider sees it. ⚠️ No dates =
   * the LAST FULL CALENDAR MONTH, decided by the server.
   */
  statement(
    ownerId: string,
    range?: { from?: string; to?: string }
  ): Promise<ContentStatement> {
    const q = new URLSearchParams();
    if (range?.from) q.set("from", range.from);
    if (range?.to) q.set("to", range.to);
    const query = q.toString();
    return unwrap(
      fetch(
        `/api/cms/v1/content-owners/${encodeURIComponent(ownerId)}/statement${
          query ? `?${query}` : ""
        }`
      )
    );
  },

  /** ONE order by the ref the customer quotes. There is no list. */
  order(orderRef: string): Promise<SupportOrderView> {
    return unwrap(fetch(supportUrl(orderRef)));
  },

  revoke(
    orderRef: string,
    reason: string
  ): Promise<{
    grantId: string;
    endedStreams: number;
    order: SupportOrderView;
  }> {
    return unwrap(
      fetch(`${supportUrl(orderRef)}/revoke`, jsonBody("POST", { reason }))
    );
  },

  /** Asks Stripe; the grant goes when the refund webhook arrives. */
  refund(orderRef: string, reason: string): Promise<{ refundRequested: true }> {
    return unwrap(
      fetch(`${supportUrl(orderRef)}/refund`, jsonBody("POST", { reason }))
    );
  },
};

function supportUrl(orderRef: string): string {
  return `/api/cms/v1/support/orders/${encodeURIComponent(orderRef.trim())}`;
}
